<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      机场站<br>
站点介绍<br>
机场设于机场航站楼及交通中心下。北侧为机场T3航站楼，在航站楼南侧为机场交通中心，交通中心南侧目前规划为景观空地。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:01	00:01	11号线	4分钟	6分32秒<br>
碧头	06:32	00:05	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:01	00:01	11号线	4分34秒	6分钟<br>
碧头	06:32	00:05	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:01	00:01	11号线	4分37秒	6分钟<br>
碧头	06:32	00:05	11号线	4分37秒	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
穗深城际铁路<br><br>
B出入口:<br>
（暂未开启)地面交通中心层（一层）、深圳机场汽车站（因配合机场防疫机场汽车站移至二楼）<br><br>
C出入口:<br>
地面交通中心（二层）、机场站新航站楼公交总站<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 肿瘤医院站<br>
M303、M304（龙东方向）、M306、M322、M357、M447、M458、N28、高峰专线193路、M304（爱联方向）<br><br>
A出入口:<br>
公交站名： 肿瘤医院站<br>
M303、M304（龙东方向）、M306、M322、M357、M447、M458、N28、高峰专线193路、M304（爱联方向）<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>